







import Vue from 'vue'
import SlideControl from './SlideControl.vue'

export default Vue.extend({
  props: {
    errorReason: String,
    option: Object
  },
  components: {
    SlideControl
  }
})
